import { isSizeBasedAnchor } from "./anchors";
import { METADATA_PRODUCER_NAME_FULL } from "./constants";

/**
 * References:
 * - https://archimedespalimpsest.net/Documents/External/XMP/XMPSpecificationPart1.pdf
 * - https://archimedespalimpsest.net/Documents/External/XMP/XMPSpecificationPart2.pdf
 * - https://archimedespalimpsest.net/Documents/External/XMP/XMPSpecificationPart3.pdf
 * - https://github.com/Hopding/pdf-lib/issues/55#issuecomment-527447921
 */

// XMP specs recommend whitespace padding or 2-4KB within xpacket (see XMPSpecificationPart3.pdf).
const whitespacePadding = new Array(20).fill(" ".repeat(100)).join("\n");

export function createXMPMetadata(anchors) {
  const anchorList = createAnchorListXML(anchors);

  // The id "W5M0MpCehiHzreSzNTczkc9d" is hardcoded requirement in spec.
  return `
    <?xpacket begin="" id="W5M0MpCehiHzreSzNTczkc9d"?>
      <x:xmpmeta xmlns:x="adobe:ns:meta/">
        <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
          <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreatorTool>${METADATA_PRODUCER_NAME_FULL}</xmp:CreatorTool>
            <xmp:CreateDate>${new Date().toISOString()}</xmp:CreateDate>
          </rdf:Description>

          <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${METADATA_PRODUCER_NAME_FULL}</pdf:Producer>
          </rdf:Description>

          <rdf:Description rdf:about="" xmlns:qwt="http://ns.qwil.io/qwt/1.0/">
            ${anchorList}
          </rdf:Description>
        </rdf:RDF>
      </x:xmpmeta>
      ${whitespacePadding}
    <?xpacket end="w"?>
  `.trim();
}

function createAnchorListXML(anchors) {
  // fake dom object which we and populate then serialize as XML
  const doc = document.implementation.createDocument("", "", null);

  const anchorList = doc.createElement("qwt:anchorList");
  doc.appendChild(anchorList);

  for (let key in anchors) {
    if (anchors.hasOwnProperty(key)) {
      const a = anchors[key];

      let anchorElem = doc.createElement("qwt:anchor");
      let isSizeBased = isSizeBasedAnchor(a.name);
      anchorList.appendChild(anchorElem);
      anchorElem.setAttribute("name", a.name);
      anchorElem.setAttribute("imgref", a.imageRef);

      a.locations.forEach(function (location) {
        let locationElem = doc.createElement("qwt:location");
        anchorElem.appendChild(locationElem);
        locationElem.setAttribute("page", location.page);
        // BE expects top-left of element using canvas coordinates (so 0,0 is top left of page)
        locationElem.setAttribute("x", location.left);
        locationElem.setAttribute("y", location.top);
        if (isSizeBased) {
          locationElem.setAttribute("width", location.width);
          locationElem.setAttribute("height", location.height);
        }
      });
    }
  }

  return new XMLSerializer().serializeToString(doc);
}

export function xmlContainsQwilAnchors(xml) {
  return xml.includes("qwt:anchorList");
}
